(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guide-library"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('guide-library-search')) {
    customElements.define('guide-library-search', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('.guide-library__search');
        this.input = this.form.querySelector('[name="q"]');
        this.results = this.querySelector('[data-guide-search-results]');
        this.content = this.querySelector('[data-guide-search-content]');
        this.status = this.querySelector('[data-guide-search-status]');
        this.browse = this.querySelector('[data-guide-browse]');
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.search();
        });
        this.querySelector('[data-guide-search-clear]').addEventListener('click', () => {
          this.request?.abort();
          this.results.hidden = true;
          this.browse.hidden = false;
          this.input.value = '';
          this.input.focus();
        });
        this.addEventListener('click', (event) => {
          const brand = event.target.closest('[data-guide-brand-search]');
          const next = event.target.closest('[data-guide-search-more]');
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (brand) {
            event.preventDefault();
            this.input.value = brand.dataset.guideBrandSearch;
            this.search();
          } else if (next) {
            event.preventDefault();
            this.renderMore();
          }
        });
      }

      disconnectedCallback() {
        this.request?.abort();
      }

      search() {
        if (!this.input.value.trim()) return;
        const url = new URL(this.form.action, window.location.origin);
        url.search = new URLSearchParams(new FormData(this.form)).toString();
        this.load(url);
      }

      renderMore() {
        const grid = this.content.querySelector('[data-guide-search-grid]');
        grid.append(...this.pendingCards.splice(0, 12));
        this.content.querySelector('[data-guide-search-pagination]')?.remove();
        if (this.pendingCards.length) {
          const pagination = document.createElement('div');
          pagination.className = 'guide-library__load-more';
          pagination.setAttribute('data-guide-search-pagination', '');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'button';
          button.setAttribute('data-guide-search-more', '');
          button.textContent = this.dataset.guideMore;
          pagination.append(button);
          this.content.append(pagination);
        }
      }

      async load(address) {
        this.request?.abort();
        const controller = new AbortController();
        this.request = controller;
        this.results.hidden = false;
        this.browse.hidden = true;
        this.results.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.guideLoading;
        this.content.replaceChildren();
        try {
          const cards = [];
          const visited = new Set();
          let nextAddress = address;
          while (nextAddress) {
            const url = new URL(nextAddress, window.location.origin);
            url.searchParams.set('view', 'guide-library');
            url.searchParams.set('type', 'article');
            if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid search page');
            visited.add(url.href);
            const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) throw new Error('Search unavailable');
            const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fragment = documentResult.querySelector('[data-guide-search-fragment]');
            const grid = fragment?.querySelector('[data-guide-search-grid]');
            if (!grid) throw new Error('Search results unavailable');
            cards.push(...grid.children);
            nextAddress = fragment.querySelector('[data-guide-search-next]')?.getAttribute('href');
          }
          if (controller.signal.aborted || this.request !== controller) return;
          this.status.textContent = cards.length === 1 ? this.dataset.guideCountOne : this.dataset.guideCountOther.replace('[count]', cards.length);
          if (cards.length) {
            const grid = document.createElement('div');
            grid.className = 'guide-library__grid';
            grid.setAttribute('data-guide-search-grid', '');
            this.content.replaceChildren(grid);
            this.pendingCards = cards;
            this.renderMore();
          } else {
            const empty = document.createElement('p');
            empty.textContent = this.dataset.guideEmpty;
            this.content.replaceChildren(empty);
          }
          const heading = this.querySelector('[data-guide-search-heading]');
          heading.focus({ preventScroll: true });
          this.results.scrollIntoView({ block: 'start' });
        } catch (error) {
          if (error.name !== 'AbortError' && this.request === controller) this.status.textContent = this.dataset.guideError;
        } finally {
          if (this.request === controller) this.results.setAttribute('aria-busy', 'false');
        }
      }
    });
  }

  if (!customElements.get('guide-load-more')) {
    customElements.define('guide-load-more', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link) return;
        this.link.addEventListener('click', this.load.bind(this));
      }

      async load(event) {
        event.preventDefault();
        if (this.classList.contains('is-loading')) return;
        this.classList.add('is-loading');

        try {
          const response = await fetch(this.link.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load guides');
          const html = await response.text();
          const nextDocument = new DOMParser().parseFromString(html, 'text/html');
          const currentGrid = this.closest('[data-guide-library]').querySelector('[data-guide-grid]');
          const nextGrid = nextDocument.querySelector('[data-guide-grid]');
          const nextControl = nextDocument.querySelector('[data-guide-next] a');

          if (nextGrid) {
            [...nextGrid.children].forEach((card) => currentGrid.appendChild(card));
          }

          if (nextControl) {
            this.link.href = nextControl.href;
            const nextStatus = nextDocument.querySelector('.guide-library__page-status');
            const currentStatus = this.querySelector('.guide-library__page-status');
            if (currentStatus && nextStatus) currentStatus.textContent = nextStatus.textContent;
            this.classList.remove('is-loading');
          } else {
            this.remove();
          }
        } catch (error) {
          window.location.assign(this.link.href);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
